import { render, staticRenderFns } from "./ValidateTemplate.vue?vue&type=template&id=53bfab2a&"
import script from "./ValidateTemplate.vue?vue&type=script&lang=js&"
export * from "./ValidateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports